import { AvField, AvForm } from 'availity-reactstrap-validation';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from 'reactstrap';
import { coeffAbattEvActions } from './coeffAbattSlice';

const initForm = {
    entretReg: null,
    identFiscale: '',
    ice: '',
    prestataire:'',
    percentYear1: '',
    percentYear2: '',
    percentFromYear3: '',

}
const CoefficiantAbattForm = ({ editingItem }) => {
    const { t } = useTranslation('translation');
    const { entretReg } = useSelector(state => state.data);
    const [form, setForm] = useState(initForm);
    const dispatch = useDispatch();

    useEffect(() => {
        if (editingItem) {
            setForm({ ...editingItem });
        }
    }, [editingItem]);

    const formik = useFormik({
        initialValues: { ...form },
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            let payload = {
                data: values,
                onSuccess: () => {
                    dispatch(coeffAbattEvActions.listCoeffAbattEv());
                }
            };

            if (values?.id > 0) {
                dispatch(coeffAbattEvActions.updateCoeffAbattEv(payload));
            } else {
                dispatch(coeffAbattEvActions.createCoeffAbattEv(payload));
            }

            resetForm()
        }
    });

    const { getFieldProps, values } = formik;

    return (
        <React.Fragment>

            <AvForm className="needs-validation" onValidSubmit={formik.handleSubmit} >
                <Label className="form-label" htmlFor="annee5">{t('parametrage.typeEntretien')}</Label>

                {entretReg?.map((item, index) => (
                    <div key={index} className="mb-3 form-check">
                        <AvField
                            type="radio"
                            {...getFieldProps('entretReg')}
                            value={item.code}
                            className="form-check-input"
                            id={`item_${index}`}
                            checked={values.entretReg === item.code}
                        />
                        <label className="form-check-label" htmlFor={`typeEntretien_${index}`}>{t(item.description)}</label>
                    </div>
                ))}
                <Row>
                    <Col md="4">
                        <label className="form-check-label">{t('parametrage.prestataire')}</label>
                        <AvField
                            {...getFieldProps('prestataire')}
                            type="text"
                            placeholder={t('parametrage.prestataire')}
                            errorMessage={t('message.required')}
                            className="form-control"
                            id="id"
                        />
                    </Col>
                    <Col md="4">
                        <label className="form-check-label">{t('parametrage.idFiscal')}</label>
                        <AvField
                            {...getFieldProps('identFiscale')}
                            type="text"
                            placeholder={t('parametrage.idFiscal')}
                            errorMessage={t('message.required')}
                            className="form-control"
                            id="id"
                        />
                    </Col>
                    <Col md="4">
                        <label className="form-check-label">{t('parametrage.ice')}</label>
                        <AvField
                            {...getFieldProps('ice')}
                            type="text"
                            placeholder={t('parametrage.ice')}
                            errorMessage={t('message.required')}
                            className="form-control"
                            id="ice"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md="3">
                        <label className="form-check-label">{t('parametrage.annee1')}</label>
                        <AvField
                            {...getFieldProps('percentYear1')}
                            type="text"
                            placeholder={t('parametrage.annee1')}
                            errorMessage={t('message.required')}
                            className="form-control"
                            id="annee1"
                        />
                    </Col>
                    <Col md="3">
                        <label className="form-check-label">{t('parametrage.annee2')}</label>
                        <AvField
                            {...getFieldProps('percentYear2')}
                            type="text"
                            placeholder={t('parametrage.annee2')}
                            errorMessage={t('message.required')}
                            className="form-control"
                            id="annee3"
                        />
                    </Col>
                    <Col md="3">
                        <label className="form-check-label">{t('parametrage.apartirAnnee3')}</label>
                        <AvField
                            {...getFieldProps('percentFromYear3')}
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            id="annee3"
                        />
                    </Col>
                </Row>
                <Col md="12" className="d-flex justify-content-end">
                    <Button color="primary" size="sm" type="submit">{t('actions.save')}</Button>
                    <Button color="danger" size="sm" type='reset' className="mx-2" onClick={() => setForm({ ...initForm })}>{t('actions.clear')}</Button>
                </Col>
            </AvForm>
        </React.Fragment>
    )
}

export default CoefficiantAbattForm